import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ManageInvitationsContent from '../components/pages/user/manage-invitations/content';

function ManageInvitationsContainer(props) {
  const dispatch = useDispatch();
  const selectedUserInvitationForm = useSelector((state) => state.usersReducer.selectedUserInvitationForm);
  const timezone = useSelector((state) => state.usersReducer.userProfile.timezoneOffsetNow);

  return (
    <ManageInvitationsContent
      selectedUser={props.selectedUser}
      selectedUserInvitationForm={selectedUserInvitationForm}
      timezone={timezone}
      dispatch={dispatch}
    />
  );
}

export default ManageInvitationsContainer;
